<template>
	<footer>
		<div v-if="loadExternalFooter" v-html="footerContent">
		</div>
		<div v-else>
			<div class="container">
				<div class="row">
					<div class="col-lg-8 col-sm-12">
						<div class="row">
							<div class="col-lg-3 col-sm-12 col-md-6" v-if="!$gstate.isProFlow()">
								<h5>Product</h5>
								<ul>
									<li><a target="_blank" v-bind:href="directURL">Coincurve Direct</a></li>
								</ul>
							</div>
							<div class="col-lg-3 col-sm-12 col-md-6">
								<h5>Company</h5>
								<ul>
									<li><a target="_blank" v-bind:href="aboutURL">About</a></li>
									<li><a target="_blank" v-bind:href="newsURL">News</a></li>
									<li><a target="_blank" v-bind:href="careersURL">Careers</a></li>
								</ul>
							</div>
							<div class="col-lg-3 col-sm-12 col-md-6">
								<h5>Support</h5>
								<ul>
									<li><a target="_blank" v-bind:href="featuresURL">Features</a></li>
									<li><a target="_blank" v-bind:href="limitsURL">Limits</a></li>
									<li v-if="!$gstate.isProFlow()"><a target="_blank" v-bind:href="faqURL">FAQ</a></li>
									<li><a target="_blank" v-bind:href="helpDeskURL">Help Desk</a></li>

								</ul>
							</div>
							<div class="col-lg-3 col-sm-12 col-md-6">
								<h5>Legal</h5>
								<ul>
									<li><a target="_blank" v-bind:href="tosURL">Terms of Service</a></li>
									<li><a target="_blank" v-bind:href="ppURL">Privacy Policy</a></li>
									<li><a target="_blank" v-bind:href="cpURL">Compliance Policy</a></li>
									<li><a target="_blank" v-bind:href="refundURL">Refund Policy</a></li>
								</ul>
							</div>
						</div>
					</div>
					<div class="col-lg-4 col-sm-12">
						<div class="row">
							<div class="col-lg-6 col-sm-12 d-md-none d-lg-block"></div>
							<div class="col-lg-6 col-sm-12">
								<h5>Community</h5>
								<div class="social-icon"><a href="https://twitter.com/coincurve" target="_blank"><i class="fab fa-twitter"></i></a></div>
								<div class="social-icon"><a href="https://www.instagram.com/coincurve" target="_blank"><i class="fab fa-instagram"></i></a></div>
								<div class="social-icon"><a href="https://www.facebook.com/coincurve" target="_blank"><i class="fab fa-facebook"></i></a></div>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-12">
						<hr>
						<p class="copy">© {{ currentYear }} <a style="color: #d1b9ea;" target="_blank" href="https://interlapse.com/">Interlapse Technologies Corp.</a> All rights reserved.  Designated trademarks and brands are the property of their respective owners. Any merchants represented are not sponsors of Coincurve or otherwise affiliated with Coincurve.</p>
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	data() {
        return {
			loadExternalFooter: true,
            footerContent: ''
        };
    },
    created(){

		// load merchant footer if not coincurve
		if(this.$gstate.isCoincurve()){
			this.loadExternalFooter = false;
		} else {
			this.loadFooter();
		}

	},
	methods: {
		loadFooter(){
			var urlstr = "static/html/merchant/" + this.$gstate.getMerchant().toLowerCase() + "/footer.html";
			this.loadExternalFooter = true

			this.axios.get(urlstr)
			.then(response => {
				this.footerContent = response.data;
			});
		}
	},
	computed: {
		featuresURL: function() {
			return this.$gstate.getSiteURL() + '/features';
		},
		limitsURL: function() {
			return this.$gstate.getSiteURL() + '/limits';
		},
		aboutURL: function() {
			return this.$gstate.getSiteURL() + '/about';
		},
		careersURL: function() {
			return this.$gstate.getSiteURL() + '/careers';
		},
		faqURL: function() {
			return this.$gstate.getSiteURL() + '/faq';
		},
		contactURL: function() {
			return this.$gstate.getSiteURL() + '/contact';
		},
		helpDeskURL: function() {
			return 'http://support.coincurve.com';
		},
		ppURL: function() {
			return this.$gstate.getSiteURL() + '/privacy-policy';
		},
		tosURL: function() {
			return this.$gstate.getSiteURL() + '/terms-of-service';
		},
		cpURL: function() {
			return this.$gstate.getSiteURL() + '/compliance-policy';
		},
		refundURL: function() {
			return this.$gstate.getSiteURL() + '/refund-policy';
		},
		newsURL: function() {
			return this.$gstate.getSiteURL() + '/latest-news';
		},
		directURL: function() {
			return 'https://direct.coincurve.com';
		},
		currentYear: function() {
			return new Date().getFullYear();
		}
	}
};
</script>